/**
 * Hardcoded stage association type definitions.
 *
 * @deprecated These constants exist as a fallback for contexts where the
 * dynamic schema data (from useAssociationTypes) is not available. Prefer
 * using `useAssociationTypes` hook which builds these sets dynamically from
 * `target_entity_kind_name === 'stage'` in the schema API. This supports
 * custom entity types without code changes.
 *
 * Consumers that still import from here:
 * - `registry/utils.ts` — fallback when no dynamic set is passed to getActionKey
 * - `useCurrentStageValue.ts` — fallback when schema data hasn't loaded yet
 */

/**
 * Set of all association type names that represent stage assignments.
 * @deprecated Use `stageAssociationTypes` from `useAssociationTypes` hook instead.
 */
export const STAGE_ASSOCIATION_TYPES_SET = new Set([
  'ahoy_contact_to_lifecycle_stage',
  'ahoy_deal_to_deal_pipeline_stage',
  'ahoy_task_to_task_pipeline_stage',
]);

/**
 * Maps stage association type name → source entity type.
 * @deprecated Use `associationTypeMap` from `useAssociationTypes` hook instead.
 */
export const STAGE_ASSOC_TO_ENTITY_TYPE: Partial<
  Record<string, 'ahoy_contact' | 'ahoy_deal' | 'ahoy_task'>
> = {
  ahoy_contact_to_lifecycle_stage: 'ahoy_contact',
  ahoy_deal_to_deal_pipeline_stage: 'ahoy_deal',
  ahoy_task_to_task_pipeline_stage: 'ahoy_task',
};

/**
 * Maps entity type → stage association type name.
 * @deprecated Use `stageAssocForEntityType` from `useAssociationTypes` hook instead.
 */
export const ENTITY_TYPE_TO_STAGE_ASSOC: Partial<Record<string, string>> = {
  ahoy_deal: 'ahoy_deal_to_deal_pipeline_stage',
  ahoy_contact: 'ahoy_contact_to_lifecycle_stage',
  ahoy_task: 'ahoy_task_to_task_pipeline_stage',
};
